import { render } from "./RuleView.vue?vue&type=template&id=313fb398"
import script from "./RuleView.vue?vue&type=script&lang=js"
export * from "./RuleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "313fb398"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('313fb398', __exports__)) {
    api.reload('313fb398', __exports__)
  }
  
  module.hot.accept("./RuleView.vue?vue&type=template&id=313fb398", () => {
    api.rerender('313fb398', render)
  })

}


export default __exports__